import {BaseModel} from '../../_base/crud';

export class AssetClassDetailLandParcelModel extends BaseModel {
    id: number;
    name: string;
    asset_class_detail_id: number;
    coordinate_reference_system_id: number;
    coordinate_reference_system_name: string;

    ac_detail_lp_path: any[];
    ac_detail_consideration: any[];

    current_occupier: string;
    previous_occupier: string;
    rrr_over_land: string;
    additional_rrr_over_land: string;
    difference_between_boundaries: string;

    ac_detail_land_area: any[];
    planning_status_id: number;
    planning_status_name: string;

    land_cover_type: string;
    qos_degradation_id: number;
    qos_degradation_name: string;
    comparative_land_use_id: number;
    comparative_land_use_name: string;
    sol_use_classification_id: number;
    sol_use_classification_name: string;
    other_characteristics: string;
    land_use_approval_implementation: string;
    building_exist: number;
    building_count: number;
    description: string;
    plot_area: number;

    road_access: number;
    status_and_quality: string;
    access_points: string;
    road_length: string;
    owner_of_another_consent: string;
    facilities: string;
    specify_other_service: string;
    ac_detail_lp_buildings: any[];

    env_considerations: string;
    other_considerations: string;

    created_at: Date;
    updated_at: Date;
    deleted_at: Date;

    clear() {
        this.id = undefined;
        this.name = '';
        this.asset_class_detail_id = undefined;
        this.coordinate_reference_system_name = undefined;

        this.ac_detail_lp_path = [];
        this.ac_detail_consideration = [];

        this.current_occupier = '';
        this.previous_occupier = '';
        this.rrr_over_land = '';
        this.additional_rrr_over_land = '';
        this.difference_between_boundaries = '';

        this.ac_detail_land_area = [];
        this.planning_status_id = undefined;
        this.planning_status_name = '';

        this.land_cover_type = '';
        this.qos_degradation_id = undefined;
        this.qos_degradation_name = '';
        this.comparative_land_use_id = undefined;
        this.comparative_land_use_name = '';
        this.sol_use_classification_id = undefined;
        this.sol_use_classification_name = '';
        this.other_characteristics = '';
        this.land_use_approval_implementation = '';
        this.building_exist = 2; // 2 means dont know
        this.building_count = 0;
        this.description = ''
        this.plot_area = null

        this.road_access = 0;
        this.status_and_quality = '';
        this.access_points = '';
        this.road_length = '';
        this.owner_of_another_consent = '';
        this.facilities = '';
        this.specify_other_service = '';
        this.ac_detail_lp_buildings = [];

        this.created_at = new Date();
        this.updated_at = new Date();
        this.deleted_at = null;
    }
}
